<script lang="ts">
    import { Col,Button ,Tooltip} from "sveltestrap";
    import { Clickme, HTMLelements, TooltipwithHTML } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    const placements  = ["right", "bottom", "left"];
    let istop : boolean = false;
    let isright: boolean = false;
    const handletooltip = (id : string) => {
      if (id == "btn-top") {
        istop = !istop;
      } else if (id == "btn-right") {
        isright = !isright;
      }
    };
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={HTMLelements} CardBodyprops="btn-showcase">
      <div slot="contentbody">
        <Button
        color="primary"
        on:click={() => handletooltip("btn-top")}
        id="btn-top">{Clickme}</Button>
        <Tooltip bind:istop target="btn-top" placement="top">{TooltipwithHTML}</Tooltip>
        {#each placements as placement}
          <Button
            color="primary"
            on:click={() => handletooltip(placement)}
            id={`btn-${placement}`}>{Clickme}</Button>
          <Tooltip bind:isright target={`btn-${placement}`} {placement}>{TooltipwithHTML}</Tooltip>
      {/each}
    </Card>
</Col>